import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { NbDialogService, NbToastrService } from "@nebular/theme";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import * as _ from "lodash";
import { FormGroup } from "@angular/forms";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { Product, ProductInventory } from "../../models/product.model";
import { ProductInventoryService } from "../../services/product-inventory.service";
import { DialogProductInventoryComponent } from "../dialog-product-inventory/dialog-product-inventory.component";

@Component({
  selector: "ngx-view-list-inventories",
  styleUrls: ["./view-list-inventories.component.scss"],
  templateUrl: "./view-list-inventories.component.html",
})
export class ViewListInventoriesComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() product: Product;
  @Input() inventories?: ProductInventory[] = [];
  @Output() onChangeData: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  diaForm: FormGroup;

  @ViewChild("comment") comment: ElementRef;
  strSearch = "";
  uid = "anonymous";
  type = "receive"; //receive/issue
  issueDate: Date = new Date();

  constructor(
    private userService: UserService,
    private inventoryService: ProductInventoryService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectType(value) {
    this.type = value;
  }

  receiveInventory(): void {
    this.dialogService
      .open(DialogProductInventoryComponent, {
        context: {
          shopId: this.shopId,
          product: this.product,
          isReceive: true,
          isEdit: false,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: ProductInventory) => {
        if (value) {
          console.log("receiveInventory:", value);
        }
      });
  }

  issueInventory(): void {
    this.dialogService
      .open(DialogProductInventoryComponent, {
        context: {
          shopId: this.shopId,
          product: this.product,
          isReceive: false,
          isEdit: false,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: ProductInventory) => {
        if (value) {
          console.log("issueInventory:", value);
        }
      });
  }

  remove(item: ProductInventory) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.inventoryService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  onEdit(item: ProductInventory): void {
    let itemMore = _.clone(item);
  }
}
